import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import PreviewHtml from '@/components/cpscc/previewHtml';
import { getList } from '@/api/setting/dictionary';
import { create, getDetail as _getDetail, update, updateDetail, getExpressInfo as _getExpressInfo, batchFlow, testSingleC02, uploadByCreator, uploadByCpsccAdmin, downloadFileByCreator, updateECodeStatus, toGetFetchSfWaybills2, toGetRoute2, toGetRoute, toGetSendRoute, toGetFetchSfWaybills, getHistoryDetail } from '@/api/correspondence/task/form';
import { getList as _getTemplateList, getTaskTmp as _getTemDetail } from '@/api/template';
import TemplateContent from './components/template-content';
import validate from '@/validate/validate';
import { mapActions, mapState } from 'vuex';
import { getReceiver, getReceiversList as _getReceiversList } from '@/api/correspondence/object';
import to from '@/libs/awaitToJs';
import { fileUpload, getEditorFileSrc } from '@/api/upload';
import { createObjectURL, getBackConfirmExplain } from '@/util';
import { transformParamsToData, transformParamsToDataV2 } from '@/components/common/transformData';
import Record from './components/record';
import CustomMap from '@/components/map/map';
import { getC02Item, getHistoryC02Item } from '@/api/correspondence/task/manager';
import { getDetail as _getTaskDetail } from '@api/setting/task/create';
import PopoverPreDoc from '@/components/correspondence/popover-pre-doc';
import dayjs from 'dayjs';
import ExpressDetail from './components/express-detail';
import ExproessDetail2 from './components/exproess-detail2';
import Details from '@/views/correspondence/object/components/details';
import HistoryComponent from '@/views/correspondence/batch/history-component';
import { toDayJs } from '@/filters';
import PrintCode from './components/print-code';
import JsBarcode from 'jsbarcode';
import Altimeter from './components/altimeter';
export default {
  name: 'correspondence-task-form',
  props: {
    id: {
      required: true
    },
    uid: {
      default: function _default() {
        return undefined;
      }
    },
    history: {
      default: function _default() {
        return false;
      }
    }
    // formType: {
    //   default () {
    //     return undefined
    //   }
    // },
    // tabTitle: {
    //   default () {
    //     return undefined
    //   }
    // }
  },
  components: {
    PreviewHtml: PreviewHtml,
    PopoverPreDoc: PopoverPreDoc
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin/page', ['opened', 'current' // 用户获取当前页面的地址，用于关闭
  ])), mapState('d2admin/user', ['info'])), mapState('cpscc', ['userInfo', 'sendCompany', 'isHX', 'localStorageName', 'backConfirmExplainList'])), {}, {
    isHZTData: function isHZTData() {
      return this.cpsccAdminStore.sender === this.baseForm.c02SendStaff && this.baseForm.c02SendType === '邮寄发函';
    },
    canBeSearchExpress: function canBeSearchExpress() {
      return this.baseData.c02ObjAddress && this.baseData.c02SendNumber && this.baseData.c02SendCompany && this.baseData.c02SendAddress;
    },
    canBeSearchExpress2: function canBeSearchExpress2() {
      return this.baseData.c02ObjAddress && this.baseData.c02BackCompany && this.baseData.c02BackNumber;
    },
    showTmpTips: function showTmpTips() {
      var _this = this;
      if (this.baseForm.c02TmpId && this.baseForm.c02Type) {
        var tmpItem = this.templateList.find(function (item) {
          return item.ctId === _this.baseForm.c02TmpId;
        });
        var tmpName;
        if (tmpItem) {
          tmpName = tmpItem.ctName;
        }
        var typeName = this.types.find(function (item) {
          return item === _this.baseForm.c02Type;
        });
        if (typeName && tmpName) {
          return tmpName.indexOf(typeName) === -1;
        }
      }
      return false;
    },
    batchHandleList: function batchHandleList() {
      var isCpscAdmin = this.isCpscAdmin;
      var list = [{
        text: '置为草稿',
        key: 'revoke',
        disabled: this.baseForm.c02Status === '已回函' || this.baseForm.c02Status === '已发函' || this.baseForm.c02Status === '作废' || this.baseForm.c02Status === '草稿'
      }, {
        text: '置为待审',
        key: 'submit',
        disabled: !(this.baseForm.c02Status === '草稿' && this.baseForm.c02Status !== '作废' && this.stepTwoPermissions)
      },
      // {
      //   text: '置为已发函',
      //   key: (this.isCpscAdmin && this.baseForm.c02Status === '已回函') ? 'rewind' : 'send',
      //   disabled: !(this.isCpscAdmin && this.baseForm.c02Status === '已回函') || this.baseForm.c02Status === '作废' || !(this.baseForm.c02Status === '已审核' && ((this.isGroup  || this.isAdmin) && !this.isCpscAdmin))
      //   // disabled: !((this.baseForm.c02Status === '已审核'|| (this.isCpscAdmin && this.baseForm.c02Status === '已回函')) && this.baseForm.c02Status !== '作废' && (this.isGroup  || this.isAdmin ))
      // },
      {
        text: '置为已回函',
        key: 'receive',
        disabled: !(this.baseForm.c02Status === '已发函' && this.baseForm.c02Status !== '作废' && this.stepThreePermissions)
      }, {
        text: '置为作废',
        key: 'disable',
        disabled: this.baseForm.c02Status === '已发函' || this.baseForm.c02Status === '已回函' || this.baseForm.c02Status === '作废'
      }];
      if (isCpscAdmin && this.baseForm.c02Status === '已回函') {
        list.splice(2, 0, {
          text: '置为已发函',
          key: 'rewind_minimum',
          disabled: false
        });
      } else {
        list.splice(2, 0, {
          text: '置为已发函',
          key: 'send',
          disabled: this.baseForm.c02Status === '作废' || this.baseForm.c02Status !== '已审核' || this.baseForm.c02Status === '已审核' && !(this.isGroup || this.isAdmin)
        });
      }
      return list;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isBackSFKD: function isBackSFKD() {
      return this.baseForm.c02BackCompany && this.baseForm.c02BackCompany.indexOf('顺丰') !== -1;
    },
    isSendSFKD: function isSendSFKD() {
      return this.baseForm.c02SendCompany && this.baseForm.c02SendCompany.indexOf('顺丰') !== -1;
    },
    getSysParams: function getSysParams() {
      return {
        cusName: this.objForm.c03CusName,
        returnAddress: this.baseForm.c02ReturnAddress,
        _returnStaff: this.baseForm._c02ReturnStaff,
        _returnStaffPhone: this.baseForm._c02ReturnStaffPhone,
        returnFax: this.baseForm.c02ReturnFax,
        returnMobile: this.baseForm.c02ReturnMobile,
        returnMail: this.baseForm.c02ReturnMail,
        confirmCode: this.baseForm.c02ConfirmCode,
        officeName: this.taskInfo.officeName,
        startDate: this.$options.filters.dateToCNByDayJs(this.taskInfo.startDate),
        endDate: this.$options.filters.dateToCNByDayJs(this.taskInfo.endDate),
        _startDate: this.taskInfo.endDate,
        _endDate: this.taskInfo.endDate,
        taskCusName: this.taskInfo.taskCusName,
        c02AuditCompany: this.baseForm.c02AuditCompany
      };
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isManager: function isManager() {
      return this.roles.includes('经理') || this.roles.includes('现场负责人') || this.roles.includes('合伙人');
    },
    stepActive: function stepActive() {
      var status = this.baseForm.c02Status;
      if ((this.isCpscAdmin || this.isreplyPersonnel) && status === '已回函' && this.baseForm.c02BackType === '函证中心邮件') {
        return 5;
      }
      switch (status) {
        case '草稿':
          return 0;
        case '待审核':
          return 1;
        case '已审核':
          return 2;
        case '已发函':
          return 3;
        case '已回函':
          return 4;
        default:
          return -1;
      }
    },
    rules: function rules() {
      var _this2 = this;
      var validateAddress = function validateAddress(rule, value, callback) {
        if (!value) {
          callback(new Error('请输入收件人'));
          return;
        } else if (!_this2.baseForm.c02ObjPosition) {
          callback(new Error('请输入函证收件人职位'));
          return;
        }
        callback();
      };
      var validateTel = function validateTel(rule, value, callback) {
        if (!value) {
          callback(new Error('请输入联系电话'));
          return;
        } else if (!_this2.baseForm.c02ObjTel) {
          callback(new Error('请输入备用电话'));
          return;
        }
        callback();
      };
      var validC02SendBelong = function validC02SendBelong(rule, value, callback) {
        if (_this2.baseForm.c02SendFee === undefined || _this2.baseForm.c02SendFee === '' || _this2.baseForm.c02SendFee === null) {
          callback(new Error('请输入发函费用'));
          return;
        } else if (!_this2.baseForm.c02SendBelong) {
          callback(new Error('请选择费用所属'));
          return;
        }
        callback();
      };
      var validateReturnStaff = function validateReturnStaff(rule, value, callback) {
        if (!_this2.baseForm._c02ReturnStaff || !_this2.baseForm._c02ReturnStaffPhone) {
          callback(new Error('请完善函证问题联系人信息'));
          return;
        }
        callback();
      };
      var validateCheckProcess = function validateCheckProcess(rule, value, callback) {
        if (_this2.baseForm.c02CheckType === '人工' && !value) {
          callback(new Error('请完善注册vs收件地址核查过程说明'));
          return;
        }
        callback();
      };
      var validateC02CheckDistance = function validateC02CheckDistance(rule, value, callback) {
        if (_this2.baseForm.c02CheckType === '人工') {
          return callback();
        } else if (value === '' || value === undefined) {
          return callback(new Error('请计算收寄地址距离'));
        }
        return callback();
      };
      var validateC02ObjTel = function validateC02ObjTel(rule, value, callback) {
        if (_this2.baseForm.c02SendType === '电子函证') {
          if (!_this2.baseForm._c02ObjTelName || !_this2.baseForm._c02ObjTelPhone) {
            callback(new Error('函证审核人姓名/对应银行名称'));
            return;
          }
        } else {
          if (_this2.baseForm._c02ObjTelName && !_this2.baseForm._c02ObjTelPhone) {
            callback(new Error('请输入对应银行名称'));
            return;
          } else if (!_this2.baseForm._c02ObjTelName && _this2.baseForm._c02ObjTelPhone) {
            callback(new Error('请输入函证审核人姓名'));
            return;
          }
        }
        return callback();
      };
      var validateTmp = function validateTmp(rule, value, callback) {
        if (!_this2.baseForm.c02SendFile1 && !value) {
          callback(new Error('请选择系统函证模板或上传自编函证'));
          return;
        }
        callback();
      };
      var validateC02ObjAddress = function validateC02ObjAddress(rule, value, callback) {
        if (value && value < 7) {
          if (value !== 'N/A') {
            callback(new Error('少于7个字符将被视为无效地址, 只能输入N/A'));
            return;
          }
        }
        callback();
      };
      switch (true) {
        case this.stepActive === 0:
          return {
            c02AuditCompany: [{
              required: true,
              message: '请输入被审单位全称',
              trigger: 'change'
            }],
            c02Type: [{
              required: true,
              message: '请选择函证类型',
              trigger: 'change'
            }],
            c02PeriorType: [{
              required: true,
              message: '请选择期数类型',
              trigger: 'change'
            }],
            c02Perior: [{
              required: true,
              message: '请选择函证截止日期',
              trigger: 'change'
            }],
            c02SampleType: [{
              required: true,
              message: '请选择函证样本类型',
              trigger: 'change'
            }],
            c02NeedElecSeal: [{
              required: true,
              message: '请选择是否加盖电子章',
              trigger: 'change'
            }],
            c02TmpId: [{
              trigger: 'change',
              validator: validateTmp
            }],
            // "c02Confirm": [
            //   {required: true, message: '请输入模板内容', trigger: 'change'}
            // ],
            c02ObjAddress: [{
              required: true,
              message: '请输入快递发函收件地址',
              trigger: 'change'
            }, {
              trigger: 'change',
              validator: validateC02ObjAddress
            }],
            c02ObjStaff: [{
              trigger: 'change',
              message: '请输入函证收件人',
              required: true
            }],
            c02ObjPosition: [{
              trigger: 'change',
              message: '请输入函证收件人职位',
              required: true
            }],
            c02ObjMobile: [{
              trigger: 'change',
              message: '请输入联系号码',
              required: true
            }],
            c02ReturnAddress: [{
              required: true,
              message: '请输入快递回函邮寄地址',
              trigger: 'change'
            }],
            _c02ReturnStaff: [{
              required: true,
              message: '请完善函证问题联系人',
              trigger: 'change'
            }],
            _c02ReturnStaffPhone: [{
              required: true,
              message: '请完善函证问题联系人电话',
              trigger: 'change'
            }],
            c02ReturnMobile: [{
              required: true,
              message: '请输入快递回函收件人姓名/电话',
              trigger: 'change'
            }],
            c02ReturnFax: [{
              required: true,
              message: '请输入事务所传真回函号码',
              trigger: 'change'
            }],
            c02ReturnMail: [{
              required: true,
              message: '请输入函证问题联系人邮箱',
              trigger: 'change'
            }, {
              message: '请输入正确的邮箱格式',
              trigger: 'change',
              validator: validate.isEmail
            }],
            c02CheckDistance: [{
              validator: validateC02CheckDistance,
              message: '请计算注册vs收件地址距离',
              trigger: 'change'
            }],
            c02CheckType: [{
              required: true,
              message: '请选择注册vs收件地址核查方式',
              trigger: 'change'
            }],
            c02CheckProcess: [{
              validator: validateCheckProcess,
              message: '请输入注册vs收件地址核查过程说明',
              trigger: 'change'
            }],
            c02CheckConclusion: [{
              required: true,
              message: '请选择注册vs收件地址核查结论',
              trigger: 'change'
            }],
            c02SendFile1: [{
              required: true,
              message: '请上传',
              trigger: 'change'
            }],
            c02C03Id: [{
              required: true,
              message: '请选择被函证对象全称',
              trigger: 'change'
            }],
            // c02ObjTel: [
            //   { validator: validateC02ObjTel, trigger: 'change' }
            // ],
            c02SendFile2: [{
              required: true,
              message: '请上传',
              trigger: 'change'
            }]
          };
        case this.customCheckSendForm:
          // case this.stepActive === 2:
          var r = {
            c02SendType: [{
              required: true,
              message: '请选择函证发出方式',
              trigger: 'change'
            }],
            // "c02SendRecAddress": [
            //   {required: true, message: '请输入实际收件地址', trigger: 'change'}
            // ],
            c02SendStaff: [{
              required: true,
              message: '请输入发函人',
              trigger: 'change'
            }],
            c02SendDate: [{
              required: true,
              message: '请输入发函日期',
              trigger: 'change'
            }],
            // "c02SendProcess": [
            //   {required: true, message: '请输入发函/跟函过程记录', trigger: 'change'}
            // ],
            c02SendCompany: [{
              required: true,
              message: '请选择邮寄发函快递公司',
              trigger: 'change'
            }],
            c02SendFee: [{
              required: true,
              message: '请输入发函费用',
              trigger: 'change'
            }],
            c02SendBelong: [{
              required: true,
              validator: validC02SendBelong,
              trigger: 'change'
            }],
            c02SendFeeStatus: [{
              required: true,
              message: '请选择归属客户费用回收状态',
              trigger: 'change'
            }],
            c02SendAddress: [{
              required: true,
              message: '请输入函证(跟函)地点或方式',
              trigger: 'change'
            }],
            // "c02SendRecDate": [
            //   {required: true, message: '请选择实际收件日期', trigger: 'change'}
            // ],
            c02SendNumber: [{
              required: true,
              message: '请输入邮寄发函快递单号',
              trigger: 'change'
            }]
            // c02ObjTel: [
            //   { validator: validateC02ObjTel, trigger: 'change' }
            // ]
          };
          return r;
        case this.customCheckForm:
          // case this.stepActive === 3 || this.customCheckForm:
          var validateAddressDistance = function validateAddressDistance(rule, value, callback) {
            if (_this2.baseForm.c02BackAddressCheck === '人工') {
              return callback();
            } else if (value === undefined || value === '') {
              return callback(new Error('请计算收寄地址距离'));
            }
            callback();
          };
          var validateBackCheckProcess = function validateBackCheckProcess(rule, value, callback) {
            if (_this2.baseForm.c02BackAddressCheck === '人工' && !value) {
              return callback(new Error('请输入回函验证过程'));
            }
            callback();
          };
          var validateC02BackAddressFllow = function validateC02BackAddressFllow(rule, value, callback) {
            if (_this2.baseForm.c02BackAddressStatus === '异常' && !value) {
              return callback(new Error('请输入地址异常后续跟踪说明'));
            }
            callback();
          };
          var validateC02BackConfirmFllow = function validateC02BackConfirmFllow(rule, value, callback) {
            if (_this2.baseForm.c02BackConfirmValid === '异常' && !value) {
              return callback(new Error('请输入函证初判/结论异常跟踪说明'));
            }
            callback();
          };
          var validateC02BackAddressReStatus = function validateC02BackAddressReStatus(rule, value, callback) {
            if (_this2.baseForm.c02BackAddressStatus === '异常' && _this2.baseForm.c02BackAddressFllow && !value) {
              return callback(new Error('请确认地址状态是否正常'));
            }
            callback();
          };
          var validateC02BackConfirmReConclusion = function validateC02BackConfirmReConclusion(rule, value, callback) {
            if (_this2.baseForm.c02BackConfirmValid === '异常' && _this2.baseForm.c02BackConfirmFllow && !value) {
              return callback(new Error('请确认回函是否有效'));
            }
            callback();
          };
          var rules = {
            c02BackType: [{
              required: true,
              message: '请选择回函方式',
              trigger: 'change'
            }],
            c02BackConfirmDate: [{
              required: true,
              message: '请选择回函签署日期',
              trigger: 'change'
            }],
            c02BackConfirmConclusion: [{
              required: true,
              message: '请选择函证结论',
              trigger: 'change'
            }],
            c02BackConfirmFile: [{
              required: true,
              message: '纸质回函扫描件不能为空',
              trigger: 'change'
            }],
            c02BackConfirmValid: [{
              required: true,
              message: '请选择函证初判',
              trigger: 'change'
            }],
            _c02BackConfirmExplain: [{
              required: true,
              message: '请输入说明',
              trigger: 'change'
            }],
            c02BackCompany: [{
              required: true,
              message: '请选择邮寄回函快递公司',
              trigger: 'change'
            }],
            c02BackNumber: [{
              required: true,
              message: '请录入邮寄回函快递单号',
              trigger: 'change'
            }],
            c02BackAddress: [{
              required: true,
              message: '请输入邮寄回函寄出地址',
              trigger: 'change'
            }],
            c02BackSendName: [{
              required: true,
              message: '请输入邮寄回函寄件人',
              trigger: 'change'
            }],
            c02BackSendMobile: [{
              required: true,
              message: '请输入邮寄回函寄件人电话',
              trigger: 'change'
            }],
            c02BackSendDate: [{
              required: true,
              message: '请选择邮寄回函寄出日期',
              trigger: 'change'
            }],
            c02BackConfirmActualDate: [{
              required: true,
              message: '请选择邮寄回函收件日期',
              trigger: 'change'
            }],
            c02BackFee: [{
              required: true,
              message: '请输入邮寄回函到付费用',
              trigger: 'change'
            }],
            c02BackBelong: [{
              required: true,
              message: '请选择邮寄回函费用归属',
              trigger: 'change'
            }],
            c02BackFeeStatus: [{
              required: true,
              message: '请选择邮寄回函到付费用回收状态',
              trigger: 'change'
            }]
            // "c02BackAddressDistance": [
            //   {required: true, message: '请计算收寄地址距离', trigger: 'change'}
            // ],
            // "c02BackAddressCheck": [
            //   {required: true, message: '请选择地址核对方式', trigger: 'change'}
            // ],
            // "c02BackCheckProcess": [
            //   { message: '请输入回函验证过程', trigger: 'change'}
            // ],
            // "c02BackAddressStatus": [
            //   {required: true, message: '请选择地址检查状态', trigger: 'change'}
            // ],
          };
          if (this.baseForm.c02BackAddress) {
            rules.c02BackAddressDistance = [{
              validator: validateAddressDistance,
              message: '请计算收件地址vs回函寄出地址距离',
              trigger: 'change'
            }];
            rules.c02BackAddressCheck = [{
              required: true,
              message: '请选择地收件地址vs回函寄出地址核对方式',
              trigger: 'change'
            }];
            rules.c02BackCheckProcess = [{
              validator: validateBackCheckProcess,
              message: '请输入收件地址vs回函寄出地址核验过程',
              trigger: 'change'
            }];
            rules.c02BackAddressStatus = [{
              required: true,
              message: '请选择收件地址vs回函寄出地址检查结论',
              trigger: 'change'
            }];
          }
          if (this.baseForm.c02SendType !== '现场跟函') {
            rules.c02SendRecAddress = [{
              required: true,
              message: '请输入邮寄发函物理轨迹收件地址',
              trigger: 'change'
            }];
            rules.c02SendRecDate = [{
              required: true,
              message: '请选择邮寄发函物理轨迹收件日期',
              trigger: 'change'
            }];
          }
          return rules;
        case this.stepActive === 4:
          return {
            c02BackAddressFllow: [{
              message: '请输入地址异常后续跟踪说明',
              validator: validateC02BackAddressFllow,
              trigger: 'change'
            }],
            c02BackConfirmFllow: [{
              message: '请输入函证初判/结论异常跟踪说明',
              validator: validateC02BackConfirmFllow,
              trigger: 'change'
            }],
            c02BackAddressReStatus: [{
              message: '请确认地址状态是否正常',
              validator: validateC02BackAddressReStatus,
              trigger: 'change'
            }],
            c02BackConfirmReConclusion: [{
              message: '请确认回函是否有效',
              validator: validateC02BackConfirmReConclusion,
              trigger: 'change'
            }]
          };
        case this.stepActive === 5:
          return {
            // c02GetStatus: [
            //   { required: true, message: '请选择原件状态', trigger: 'change' }
            // ],
            // c02GetStaff: [
            //   { required: true, message: '请输入领取人姓名', trigger: 'change' }
            // ],
            // c02GetDate: [
            //   { required: true, message: '请选择领取日期', trigger: 'change' }
            // ]
          };
        default:
          return {};
      }
    },
    isGroup: function isGroup() {
      if (this.roles.length > 0) {
        return this.roles.includes('经理') || this.roles.includes('现场负责人') || this.roles.includes('合伙人') || this.roles.includes('参与人员');
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    },
    isreplyPersonnel: function isreplyPersonnel() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('回函操作员');
        }
      }
      return false;
    },
    isReplyPersonnelDisabled: function isReplyPersonnelDisabled() {
      if (this.isreplyPersonnel) {
        if (this.stepActive === 0 || this.stepActive === 5) {
          return true;
        }
      }
      return false;
    },
    stepTwoPermissions: function stepTwoPermissions() {
      return this.isGroup || this.isCpscAdmin || this.isAdmin || this.isSender;
    },
    stepThreePermissions: function stepThreePermissions() {
      if (this.taskInfo.isPublic) {
        return this.isGroup || this.isCpscAdmin || this.isAdmin || this.isreplyPersonnel;
      } else {
        // if (this.baseForm.c02SendType === '邮寄发函') {
        //   return this.isCpscAdmin || this.isAdmin || this.isreplyPersonnel;
        // } else {
        //   return (this.isGroup || this.isCpscAdmin || this.isAdmin || this.isreplyPersonnel) && (!this.roles.includes('参与人员'));
        // }
        return this.isCpscAdmin || this.isAdmin || this.isreplyPersonnel;
      }
    },
    stepFivePermissions: function stepFivePermissions() {
      return this.isCpscAdmin || this.isAdmin || this.isreplyPersonnel;
    },
    formType: function formType() {
      var type = this.$route.query.type;
      return type;
    },
    c02BackTypePermission: function c02BackTypePermission() {
      // cpsccAdminPermissions ? !cpsccAdminPermissions : (!(stepActive === 3 && stepThreePermissions))
      // 如果是函证中心管理员权限可以编辑
      if (this.cpsccAdminPermissions) {
        return false;
      }
      // 判断当前进度是否在已发函

      if (this.stepActive === 3 && this.stepThreePermissions) {
        // 判断是否设置为只允许函证中心处理回函
        if (!this.taskInfo.isPublic) {
          return !(this.isCpscAdmin || this.isreplyPersonnel);
        } else {
          return !(this.isGroup || this.isCpscAdmin || this.isreplyPersonnel);
        }
      }
      return true;
    },
    backConfirmFileName: function backConfirmFileName() {
      if (this.baseForm.c02BackConfirmFile) {
        var arr = this.baseForm.c02BackConfirmFile.split('\\');
        return arr[arr.length - 1];
      }
      return undefined;
    },
    showBackConfirmDateTips: function showBackConfirmDateTips() {
      if (this.baseForm.c02BackConfirmDate) {
        // 如果超过本日
        return !toDayJs(this.baseForm.c02BackConfirmDate).isSameOrBefore(dayjs().format('YYYY-MM-DD'));
      }
      return false;
    },
    c02BackWaybillName: function c02BackWaybillName() {
      if (this.baseForm.c02BackWaybill) {
        var arr = this.baseForm.c02BackWaybill.split('\\');
        return arr[arr.length - 1];
      }
      return undefined;
    },
    c02SendWaybillName: function c02SendWaybillName() {
      if (this.baseForm.c02SendWaybill) {
        var arr = this.baseForm.c02SendWaybill.split('\\');
        return arr[arr.length - 1];
      }
      return undefined;
    },
    cpsccAdminPermissions: function cpsccAdminPermissions() {
      return (this.isCpscAdmin || this.isreplyPersonnel) && [0, 1, 2].includes(this.stepActive);
    },
    types: function types() {
      return this.$store.state.cpscc.correspondenceType;
    },
    reTypes: function reTypes() {
      return this.$store.state.cpscc.reTypes;
    }
  }),
  data: function data() {
    var baseForm = {
      _c02BackConfirmExplain: undefined,
      _c02ObjTelName: undefined,
      _c02ObjTelPhone: undefined,
      c02CreateName: '',
      c02BackWaybill: undefined,
      c02SendWaybill: undefined,
      c02AuditCompany: undefined,
      c02BackConfirmFile: undefined,
      c02ConfirmCode: undefined,
      _c02ReturnStaff: undefined,
      _c02ReturnStaffPhone: undefined,
      c02AuditDate: undefined,
      c02Type: undefined,
      c02TmpId: undefined,
      c02Confirm: undefined,
      c02C03Id: undefined,
      c02SampleType: undefined,
      c02PeriorType: undefined,
      c02Perior: undefined,
      c02NeedElecSeal: false,
      c02CheckType: undefined,
      c02CheckProcess: '<p>通过天地图查看被函证单位的注册地址与发函地址之间的距离值，该距离值【异常/正常】。</p><p>（如果距离地址异常，请在此说明原因）</p>',
      c02CheckDistance: undefined,
      c02CheckConclusion: undefined,
      c02ObjAddress: undefined,
      c02ObjStaff: undefined,
      c02ObjPosition: undefined,
      c02ObjMobile: undefined,
      c02ObjTel: undefined,
      c02SendFile1: undefined,
      c02SendFile2: undefined,
      c02SendType: undefined,
      c02SendAddress: undefined,
      c02SendCompany: undefined,
      c02SendNumber: undefined,
      c02SendStaff: undefined,
      c02SendDate: undefined,
      c02SendProcess: undefined,
      c02SendFee: undefined,
      c02SendBelong: undefined,
      c02SendFeeStatus: undefined,
      c02SendRecAddress: undefined,
      c02SendRecDate: undefined,
      c02ReturnAddress: undefined,
      c02ReturnStaff: undefined,
      c02ReturnMobile: undefined,
      c02ReturnFax: undefined,
      c02ReturnMail: undefined,
      c02CteateName: undefined,
      c02CreateDate: undefined,
      c02CheckStaffName: undefined,
      c02CheckDate: undefined,
      c02AuditName: undefined,
      c02BackType: undefined,
      c02BackConfirmDate: undefined,
      c02BackConfirmConclusion: undefined,
      c02BackConfirmValid: undefined,
      c02BackConfirmExplain: undefined,
      c02BackConfirmName: undefined,
      c02BackConfirmOperateDate: undefined,
      c02BackCompany: undefined,
      c02BackNumber: undefined,
      c02BackAddress: undefined,
      c02BackSendName: undefined,
      c02BackSendMobile: undefined,
      c02BackSendDate: undefined,
      c02BackConfirmActualDate: undefined,
      c02BackFee: undefined,
      c02BackBelong: undefined,
      c02BackFeeStatus: undefined,
      c02BackAddressDistance: undefined,
      c02BackAddressCheck: undefined,
      c02BackCheckProcess: undefined,
      c02BackAddressStatus: undefined,
      c02BackAddressFllow: undefined,
      c02BackConfirmFllow: undefined,
      c02BackAddressReStatus: undefined,
      c02BackConfirmReConclusion: undefined,
      c02BackACTrackStaffName: undefined,
      c02BackACTrackDate: undefined,
      c02GetStatus: undefined,
      c02GetStaff: undefined,
      c02GetDate: undefined,
      c02GetOperateStaffName: undefined,
      c02Status: '草稿',
      c02SendFrequency: undefined,
      c02sendfile2: undefined,
      c02Extended: undefined
    };
    var baseData = JSON.parse(JSON.stringify(baseForm));
    return {
      cpsccAdminStore: {},
      customCheckForm: false,
      customCheckSendForm: false,
      baseLoading: false,
      template: null,
      typeOptions: [],
      c02SendFile1: undefined,
      form: {},
      c02GetStatus: '',
      baseForm: baseForm,
      ewm: undefined,
      objForm: {
        c03CheckDate: undefined,
        c03CheckProcess: undefined,
        c03CheckStaff: undefined,
        c03CheckType: undefined,
        c03CorrectAddress: undefined,
        c03CusName: undefined,
        c03CusType: undefined,
        c03Id: undefined
      },
      expressNo_Send: '',
      expressNo_Back: '',
      searchLoading: false,
      dataSearchList: [],
      sendForm: {},
      replyForm: {
        c02BackType: undefined,
        c02BackConfirmDate: undefined,
        c02BackConfirmConclusion: undefined,
        c02BackConfirmValid: undefined,
        c02BackConfirmExplain: undefined,
        c02BackConfirmName: undefined,
        c02BackConfirmOperateDate: undefined,
        c02BackCompany: undefined,
        c02BackNumber: undefined,
        c02BackAddress: undefined,
        c02BackSendName: undefined,
        c02BackSendMobile: undefined,
        c02BackSendDate: undefined,
        c02BackConfirmActualDate: undefined,
        c02BackFee: undefined,
        c02BackBelong: undefined,
        c02BackFeeStatus: undefined,
        c02BackAddressDistance: undefined,
        c02BackAddressCheck: undefined,
        c02BackCheckProcess: undefined,
        c02BackAddressStatus: undefined
      },
      replyTrackingForm: {
        c02BackAddressFllow: undefined,
        c02BackConfirmFllow: undefined,
        c02BackAddressReStatus: undefined,
        c02BackConfirmReConclusion: undefined,
        c02BackACTrackStaffName: undefined,
        c02BackACTrackDate: undefined
      },
      receiveForm: {
        c02GetStatus: undefined,
        c02GetStaff: undefined,
        c02GetDate: undefined,
        c02GetOperateStaffName: undefined
      },
      objFormRules: {
        c03CusName: [{
          required: true,
          message: '请输入函证对象名称',
          trigger: 'change'
        }],
        c03CusType: [{
          required: true,
          message: '请选择函证对象类型',
          trigger: 'change'
        }],
        c03CorrectAddress: [{
          required: true,
          message: '请输入工商登记注册地址',
          trigger: 'change'
        }],
        c03CheckType: [{
          required: true,
          message: '请选择核验方式',
          trigger: 'change'
        }],
        c03CheckProcess: [{
          required: true,
          message: '请输入核验过程',
          trigger: 'change'
        }]
      },
      currentTableData: [],
      loading: false,
      correspondenceTypes: [],
      // reTypes: ['项目组邮件', '函证中心邮件', '人员跟函', '电子邮件回函', '电子函证回函', '传真回函', '其他'],
      costTypes: [{
        name: '被审客户',
        value: '被审客户'
      }, {
        name: '本所部组',
        value: '本所部组'
      }, {
        name: '不适用',
        value: '不适用'
      }],
      costStates: [{
        name: '待结算',
        value: '待结算'
      }, {
        name: '已回收',
        value: '已回收'
      }, {
        name: '不适用',
        value: '不适用'
      }],
      addressTypes: [],
      // types: ['银行询证函', '验资业务银行询证函', '企业往来询证函', '代管存货询证函', '工程合同询证函', '其他类型询证函'],
      checkTypes: [{
        text: '人工',
        disabled: false
      }, {
        text: '天地图',
        disabled: false
      }, {
        text: '百度地图',
        disabled: false
      }],
      sampleTypes: [],
      defaultDataItems: ['shunfeng', 'shunfengkuaiyun', 'youzhengguonei', 'ems', 'yuantong', 'shentong', 'shentong', 'yunda', 'jd', 'debangkuaidi', 'dhl', 'fedex', 'ups'],
      templateList: [],
      eTag: undefined,
      C21ConfirmationDataForCreation: [],
      timer: null,
      printObj: {
        // 打印配置对象
        id: 'print-content',
        popTitle: '&nbsp;',
        extraHead: '<meta http-equiv="Content-Language" content="zh-cn"/>'
      },
      tempParams: [],
      tempDetail: {},
      baseData: baseData,
      sendFormRules: [],
      taskInfo: {
        officeName: '',
        startDate: '',
        endDate: '',
        taskCusName: '',
        isPublic: false
      },
      roles: [],
      expressLoading: false,
      uploading: false,
      downloading: false,
      sendECodeIng: false,
      backRouteResult: [],
      sendRouteResult: [],
      defaultAutoExpressCompany: [{
        key: 'sf',
        name: '顺丰速运'
      }, {
        key: 'jd',
        name: '京东物流'
      }, {
        key: 'yt',
        name: '圆通速递'
      }, {
        key: 'dpk',
        name: '德邦快递'
      }, {
        key: 'jt',
        name: '极兔速递'
      }, {
        key: 'ky',
        name: '跨越速运'
      }],
      errorCodes: [],
      successCodes: []
    };
  },
  methods: _objectSpread(_objectSpread({
    getPixelRatio: function getPixelRatio(context) {
      var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    convertImageToCanvas: function convertImageToCanvas(code) {
      this.ewm = undefined;
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var ratio = this.getPixelRatio(context);
      canvas.width = 180 * ratio;
      canvas.height = 60 * ratio;
      JsBarcode(canvas, "".concat(code), {
        width: 3,
        // 设置条之间的宽度
        height: 60,
        // 高度
        fontSize: 15
      });
      this.ewm = canvas.toDataURL('image/png');
    },
    backTypeChange: function backTypeChange(val) {
      if (val === '函证中心邮件') {
        this.baseForm.c02GetStatus = '未领取';
      } else {
        this.baseForm.c02GetStatus = '不适用';
      }
      if (val === '函证中心邮件' || val === '现场邮件') {
        this.baseForm.c02BackFee = 0;
        this.baseForm.c02BackBelong = '不适用';
        this.baseForm.c02BackFeeStatus = '不适用';
      }
    },
    batchHandle: function batchHandle(command) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _yield$_this3$$awaitT, _yield$_this3$$awaitT2, formErr, _res, _yield$_this3$$awaitT3, _yield$_this3$$awaitT4, _formErr, _yield$_this3$$awaitT5, _yield$_this3$$awaitT6, err, text, notify, _yield$_this3$$awaitT7, _yield$_this3$$awaitT8, _err, _notify, _yield$_this3$$awaitT9, _yield$_this3$$awaitT0, _err2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              res = _this3.batchHandleList.find(function (item) {
                return item.key === command;
              });
              _this3.customCheckForm = false;
              _this3.customCheckSendForm = false;
              if (!(command === 'receive')) {
                _context.n = 7;
                break;
              }
              _this3.customCheckForm = true;
              _context.n = 1;
              return _this3.$nextTick();
            case 1:
              _context.n = 2;
              return _this3.$awaitTo(_this3.$checkForm());
            case 2:
              _yield$_this3$$awaitT = _context.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 1);
              formErr = _yield$_this3$$awaitT2[0];
              if (!(typeof formErr === 'boolean' && !formErr || formErr)) {
                _context.n = 3;
                break;
              }
              _this3.$message.error('请完善必要页面信息');
              return _context.a(2);
            case 3:
              if (!(_this3.baseForm.c02BackType === '项目组邮件' || _this3.baseForm.c02BackType === '函证中心邮件')) {
                _context.n = 4;
                break;
              }
              if (!(!_this3.baseForm.c02BackSendName || !_this3.baseForm.c02BackSendMobile || !_this3.baseForm.c02BackSendMobile)) {
                _context.n = 4;
                break;
              }
              _this3.$message({
                showClose: true,
                message: '寄件人/寄件联系电话/寄件时间不能为空',
                type: 'warning'
              });
              return _context.a(2);
            case 4:
              _context.n = 5;
              return _this3.$confirm("\u786E\u5B9A".concat(res.text, "?"));
            case 5:
              _context.n = 6;
              return _this3.submit(false);
            case 6:
              _context.n = 15;
              break;
            case 7:
              if (!(command === 'rewind_minimum')) {
                _context.n = 9;
                break;
              }
              _context.n = 8;
              return new Promise(function (resolve, reject) {
                _this3.$confirm('请选择是否删除本次填写数据', '确定置为已发函?', {
                  confirmButtonText: '保留数据',
                  cancelButtonText: '清除数据',
                  type: 'warning',
                  distinguishCancelAndClose: true
                }).then(function () {
                  resolve('rewind_minimum');
                }).catch(function (action) {
                  if (action === 'cancel') {
                    resolve('rewind');
                  } else {
                    reject('已取消');
                  }
                });
              });
            case 8:
              _res = _context.v;
              command = _res;
              _context.n = 15;
              break;
            case 9:
              if (!(command === 'send')) {
                _context.n = 14;
                break;
              }
              _this3.customCheckSendForm = true;
              _context.n = 10;
              return _this3.$nextTick();
            case 10:
              _context.n = 11;
              return _this3.$awaitTo(_this3.$checkForm());
            case 11:
              _yield$_this3$$awaitT3 = _context.v;
              _yield$_this3$$awaitT4 = _slicedToArray(_yield$_this3$$awaitT3, 1);
              _formErr = _yield$_this3$$awaitT4[0];
              if (!(typeof _formErr === 'boolean' && !_formErr || _formErr)) {
                _context.n = 12;
                break;
              }
              _this3.$message.error('请完善必要页面信息');
              return _context.a(2);
            case 12:
              _context.n = 13;
              return _this3.$confirm("\u786E\u5B9A".concat(res.text, "?"));
            case 13:
              _context.n = 15;
              break;
            case 14:
              _context.n = 15;
              return _this3.$confirm("\u786E\u5B9A".concat(res.text, "?"));
            case 15:
              _this3.loading = true;
              // const [err, text] = await this.$awaitTo(batchFlow(this.id, {
              //   operation: command,
              //   confirmIds: [this.uid]
              // }))
              _context.n = 16;
              return _this3.$awaitTo(testSingleC02(_this3.id, {
                operation: command,
                c02Id: _this3.uid
              }));
            case 16:
              _yield$_this3$$awaitT5 = _context.v;
              _yield$_this3$$awaitT6 = _slicedToArray(_yield$_this3$$awaitT5, 2);
              err = _yield$_this3$$awaitT6[0];
              text = _yield$_this3$$awaitT6[1];
              _this3.loading = false;
              if (!err) {
                _context.n = 17;
                break;
              }
              return _context.a(2);
            case 17:
              if (!(_this3.baseData.c02SendType === '电子函证')) {
                _context.n = 22;
                break;
              }
              if (!((command === 'rewind' || command === 'send' || command === 'rewind_minimum') && _this3.baseForm.c02SendFrequency > 0)) {
                _context.n = 20;
                break;
              }
              notify = _this3.$notify({
                title: '提示',
                message: '正在向币码同步状态...请不要关闭页面',
                duration: 0
              });
              _this3.sendECodeIng = true;
              _context.n = 18;
              return _this3.$awaitTo(updateECodeStatus(_this3.id, {
                status: '重发电子函',
                confirmCodes: [_this3.baseForm.c02ConfirmCode]
              }));
            case 18:
              _yield$_this3$$awaitT7 = _context.v;
              _yield$_this3$$awaitT8 = _slicedToArray(_yield$_this3$$awaitT7, 1);
              _err = _yield$_this3$$awaitT8[0];
              _this3.sendECodeIng = false;
              notify.close();
              if (!_err) {
                _context.n = 19;
                break;
              }
              return _context.a(2);
            case 19:
              _context.n = 22;
              break;
            case 20:
              if (!(command === 'disable' && _this3.baseForm.c02ConfirmCode)) {
                _context.n = 22;
                break;
              }
              _notify = _this3.$notify({
                title: '提示',
                message: '正在向币码同步状态...请不要关闭页面',
                duration: 0
              });
              _this3.sendECodeIng = true;
              _context.n = 21;
              return _this3.$awaitTo(updateECodeStatus(_this3.id, {
                status: '作废电子函',
                confirmCodes: [_this3.baseForm.c02ConfirmCode]
              }));
            case 21:
              _yield$_this3$$awaitT9 = _context.v;
              _yield$_this3$$awaitT0 = _slicedToArray(_yield$_this3$$awaitT9, 1);
              _err2 = _yield$_this3$$awaitT0[0];
              _this3.sendECodeIng = false;
              _notify.close();
              if (!_err2) {
                _context.n = 22;
                break;
              }
              return _context.a(2);
            case 22:
              _this3.$message.success(text);
              _this3.getDetail();
            case 23:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    updateBackFee: function updateBackFee(value) {
      if (value === 0) {
        this.baseForm.c02BackBelong = '不适用';
        this.baseForm.c02BackFeeStatus = '不适用';
      } else {
        this.baseForm.c02BackBelong = '被审客户';
        this.baseForm.c02BackFeeStatus = '待结算';
      }
    },
    backBelongChange: function backBelongChange(value) {
      if (value === '被审客户') {
        this.baseForm.c02BackFeeStatus = '待结算';
      } else {
        this.baseForm.c02BackFeeStatus = '不适用';
      }
    },
    getHZTRecord: function getHZTRecord() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this4.$awaitTo(_this4.$dialog(HistoryComponent, {
                dialog: {
                  title: '函证通下单记录',
                  width: '940px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  inDialog: true,
                  code: _this4.baseForm.c02ConfirmCode
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context2.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 1);
              err = _yield$_this4$$awaitT2[0];
              _this4.template = null;
              if (err) {}
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getSendHZTLogistics: function getSendHZTLogistics() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data, _yield$_this5$$awaitT3, _yield$_this5$$awaitT4, dialogErr, dialogData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(_this5.sendRouteResult.length === 0)) {
                _context3.n = 3;
                break;
              }
              _this5.expressLoading = true;
              _context3.n = 1;
              return _this5.$awaitTo(toGetSendRoute(_this5.baseForm.c02SendNumber));
            case 1:
              _yield$_this5$$awaitT = _context3.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1];
              _this5.expressLoading = false;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this5.sendRouteResult = data;
              }
            case 3:
              if (!(_this5.sendRouteResult.length === 0)) {
                _context3.n = 4;
                break;
              }
              _this5.$message.warning('暂无路由信息');
              return _context3.a(2);
            case 4:
              _context3.n = 5;
              return _this5.$awaitTo(_this5.$dialog(ExproessDetail2, {
                dialog: {
                  title: '函证通路由信息',
                  width: '650px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  data: _this5.sendRouteResult
                }
              }, function (template) {
                _this5.template = template;
              }));
            case 5:
              _yield$_this5$$awaitT3 = _context3.v;
              _yield$_this5$$awaitT4 = _slicedToArray(_yield$_this5$$awaitT3, 2);
              dialogErr = _yield$_this5$$awaitT4[0];
              dialogData = _yield$_this5$$awaitT4[1];
              _this5.template = null;
            case 6:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getHZTLogistics: function getHZTLogistics() {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var type, route, _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err2, data2, _yield$_this6$$awaitT3, _yield$_this6$$awaitT4, dialogErr, dialogData;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              type = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
              route = [];
              if (!(_this6.backRouteResult.length === 0)) {
                _context4.n = 3;
                break;
              }
              // this.expressLoading = true
              // const [err] = await this.$awaitTo(toGetRoute({
              //   confirmcodes: [this.baseForm.c02ConfirmCode],
              //   direction: type
              // }))
              // this.expressLoading = false
              _this6.expressLoading = true;
              _context4.n = 1;
              return _this6.$awaitTo(toGetRoute2({
                trackingNo: _this6.baseForm.c02BackNumber
              }));
            case 1:
              _yield$_this6$$awaitT = _context4.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 2);
              err2 = _yield$_this6$$awaitT2[0];
              data2 = _yield$_this6$$awaitT2[1];
              _this6.expressLoading = false;
              if (!err2) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              route = JSON.parse(JSON.parse(JSON.stringify(data2.c63RoutingHistory)));
              if (Array.isArray(route) && route.length > 0) {
                _this6.backRouteResult = route;
              }
            case 3:
              if (!(_this6.backRouteResult.length === 0)) {
                _context4.n = 4;
                break;
              }
              _this6.$message.warning('暂无路由信息');
              return _context4.a(2);
            case 4:
              _context4.n = 5;
              return _this6.$awaitTo(_this6.$dialog(ExproessDetail2, {
                dialog: {
                  title: '函证通路由信息',
                  width: '650px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  data: _this6.backRouteResult
                }
              }, function (template) {
                _this6.template = template;
              }));
            case 5:
              _yield$_this6$$awaitT3 = _context4.v;
              _yield$_this6$$awaitT4 = _slicedToArray(_yield$_this6$$awaitT3, 2);
              dialogErr = _yield$_this6$$awaitT4[0];
              dialogData = _yield$_this6$$awaitT4[1];
              _this6.template = null;
            case 6:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getHZTInfo2: function getHZTInfo2() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this7$$awaitT, _yield$_this7$$awaitT2, err, data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this7.errorCodes = [];
              _this7.successCodes = [];
              _this7.expressLoading = true;
              _context5.n = 1;
              return _this7.$awaitTo(toGetFetchSfWaybills({
                confirmcodes: [_this7.baseForm.c02ConfirmCode],
                direction: 1
              }));
            case 1:
              _yield$_this7$$awaitT = _context5.v;
              _yield$_this7$$awaitT2 = _slicedToArray(_yield$_this7$$awaitT, 2);
              err = _yield$_this7$$awaitT2[0];
              data = _yield$_this7$$awaitT2[1];
              _this7.expressLoading = false;
              if (!err) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              _this7.getDetail();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getHZTInfo: function getHZTInfo(type) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this8$$awaitT, _yield$_this8$$awaitT2, err, data, l, _l;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this8.errorCodes = [];
              _this8.successCodes = [];
              _this8.expressLoading = true;
              _context6.n = 1;
              return _this8.$awaitTo(toGetFetchSfWaybills2(_this8.uid, type === 'send' ? _this8.baseForm.c02SendNumber : _this8.baseForm.c02BackNumber, type === 'send' ? _this8.expressNo_Send : undefined));
            case 1:
              _yield$_this8$$awaitT = _context6.v;
              _yield$_this8$$awaitT2 = _slicedToArray(_yield$_this8$$awaitT, 2);
              err = _yield$_this8$$awaitT2[0];
              data = _yield$_this8$$awaitT2[1];
              _this8.expressLoading = false;
              if (!err) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              if (!(data && data.failureExplain)) {
                _context6.n = 3;
                break;
              }
              _this8.$message.error(data.failureExplain);
              return _context6.a(2);
            case 3:
              if (type === 'send') {
                if (data.filePath) {
                  _this8.baseForm.c02SendWaybill = data.filePath;
                }
                if (data.routeResult && data.routeResult.data && Array.isArray(data.routeResult.data) && data.routeResult.data.length) {
                  l = data.routeResult.data.filter(function (item) {
                    return item.mailNo === _this8.baseForm.c02SendNumber;
                  });
                  if (l.length > 0) {
                    _this8.baseForm.c02SendRecAddress = l[0].data[0].acceptAddress;
                    _this8.baseForm.c02SendRecDate = l[0].data[0].acceptTime;
                    _this8.sendRouteResult = l[0].data;
                  }
                }
              } else {
                if (data.senderAddr) {
                  _this8.baseForm.c02BackAddress = data.senderAddr;
                }
                if (data.senderName) {
                  _this8.baseForm.c02BackSendName = data.senderName;
                }
                if (data.sentOn) {
                  _this8.baseForm.c02BackSendDate = data.sentOn;
                  if (!_this8.baseForm.c02BackConfirmDate) {
                    _this8.baseForm.c02BackConfirmDate = data.sentOn;
                  }
                }
                if (data.senderMobile) {
                  _this8.baseForm.c02BackSendMobile = data.senderMobile;
                }
                if (data.filePath) {
                  _this8.baseForm.c02BackWaybill = data.filePath;
                }
                if (data.receivedOn) {
                  _this8.baseForm.c02BackConfirmActualDate = data.receivedOn;
                }
                if (data.routeResult && data.routeResult.data && Array.isArray(data.routeResult.data) && data.routeResult.data.length) {
                  _l = data.routeResult.data.filter(function (item) {
                    return item.mailNo === _this8.baseForm.c02BackNumber;
                  });
                  if (_l.length > 0) {
                    _this8.backRouteResult = _l[0].data;
                  }
                }
              }
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getExpressInfo: function getExpressInfo() {
      var _arguments2 = arguments,
        _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var type, canBeSubmit, params, _yield$_this9$$awaitT, _yield$_this9$$awaitT2, err, res, dataList, title, _yield$_this9$$awaitT3, _yield$_this9$$awaitT4, dialogErr, dialogData, _params;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              type = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : 'send';
              canBeSubmit = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
              params = {
                send: {
                  outward: true,
                  homeward: false,
                  outwardNo: _this9.expressNo_Send ? _this9.expressNo_Send : undefined
                },
                back: {
                  homeward: true,
                  outward: false,
                  homewardNo: _this9.expressNo_Back ? _this9.expressNo_Back : undefined
                },
                all: {
                  outward: true,
                  homeward: true
                }
              };
              _this9.expressLoading = true;
              _context7.n = 1;
              return _this9.$awaitTo(_getExpressInfo(_this9.id, _this9.uid, _objectSpread({}, params[type])));
            case 1:
              _yield$_this9$$awaitT = _context7.v;
              _yield$_this9$$awaitT2 = _slicedToArray(_yield$_this9$$awaitT, 2);
              err = _yield$_this9$$awaitT2[0];
              res = _yield$_this9$$awaitT2[1];
              _this9.expressLoading = false;
              if (!err) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              dataList = [];
              if (!(type === 'send')) {
                _context7.n = 4;
                break;
              }
              if (!res.explaination1) {
                _context7.n = 3;
                break;
              }
              _this9.$message.warning(res.explaination1);
              return _context7.a(2);
            case 3:
              dataList.push(_objectSpread({
                _type: 'send'
              }, res.outward));
              _context7.n = 7;
              break;
            case 4:
              if (!(type === 'back')) {
                _context7.n = 6;
                break;
              }
              if (!res.explaination2) {
                _context7.n = 5;
                break;
              }
              _this9.$message.warning(res.explaination2);
              return _context7.a(2);
            case 5:
              dataList.push(_objectSpread({
                _type: 'back'
              }, res.homeward));
              _context7.n = 7;
              break;
            case 6:
              if (type === 'all') {
                if (res.explaination1) {
                  _this9.$message.warning(res.explaination1);
                } else {
                  dataList.push(_objectSpread({
                    _type: 'send'
                  }, res.outward));
                }
                if (res.explaination2) {
                  _this9.$message.warning(res.explaination2);
                } else {
                  dataList.push(_objectSpread({
                    _type: 'back'
                  }, res.homeward));
                }
              }
            case 7:
              if (!dataList.length) {
                _context7.n = 10;
                break;
              }
              title = {
                send: '发函物流信息',
                back: '回函物流信息',
                all: '发/回函物流信息'
              };
              _context7.n = 8;
              return _this9.$awaitTo(_this9.$dialog(ExpressDetail, {
                dialog: {
                  title: title[type],
                  width: '650px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  data: dataList,
                  type: type,
                  canBeSubmit: canBeSubmit
                }
              }, function (template) {
                _this9.template = template;
              }));
            case 8:
              _yield$_this9$$awaitT3 = _context7.v;
              _yield$_this9$$awaitT4 = _slicedToArray(_yield$_this9$$awaitT3, 2);
              dialogErr = _yield$_this9$$awaitT4[0];
              dialogData = _yield$_this9$$awaitT4[1];
              _this9.template = null;
              if (!dialogErr) {
                _context7.n = 9;
                break;
              }
              return _context7.a(2);
            case 9:
              _params = {};
              if (type === 'back') {
                _params.c02BackAddressDistance = undefined;
                if (!_this9.baseForm.c02BackConfirmDate) {
                  _params.c02BackConfirmDate = dialogData.c02BackSendDate;
                }
                if (_this9.baseForm.c02BackAddressDistance !== undefined) {
                  _this9.$message.warning('请再次计算收件地址vs回函寄出地址距离');
                }
              } else if (type === 'send' && _this9.stepActive === 2) {
                _params.c02CheckDistance = undefined;
                if (_this9.baseForm.c02CheckDistance !== undefined) {
                  _this9.$message.warning('请再次计算注册vs收件地址距离');
                }
              }
              _this9.baseForm = _objectSpread(_objectSpread(_objectSpread({}, _this9.baseForm), dialogData), _params);
            case 10:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    sendDateChange: function sendDateChange() {
      if (this.baseForm.c02SendType !== '邮寄发函') {
        this.baseForm.c02SendRecDate = this.baseForm.c02SendDate ? dayjs(this.baseForm.c02SendDate).add(2, 'day').format('YYYY-MM-DD') : undefined;
      }
    },
    sendTypeChange: function sendTypeChange(val) {
      var params = {
        c02SendCompany: undefined,
        c02SendNumber: undefined,
        c02SendFee: undefined,
        c02SendBelong: undefined,
        c02SendFeeStatus: undefined,
        c02SendRecAddress: undefined
      };
      if (val !== '邮寄发函') {
        params.c02SendCompany = 'N/A';
        params.c02SendNumber = 'N/A';
        params.c02SendFee = 0;
        params.c02SendBelong = '不适用';
        params.c02SendFeeStatus = '不适用';
        params.c02SendRecAddress = this.baseForm.c02ObjAddress;
        this.sendDateChange();
        this.baseForm = _objectSpread(_objectSpread({}, this.baseForm), params);
      }
    },
    updateCheckDistance: function updateCheckDistance() {
      var checkProcess = this.objForm.c03CorrectAddress;
      if (!checkProcess) {
        this.baseForm.c02CheckDistance = -1;
      }
    },
    getTaskDetail: function getTaskDetail() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _yield$_this0$$awaitT, _yield$_this0$$awaitT2, err, data, form;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this0.$awaitTo(_getTaskDetail({
                TaskId: _this0.id
              }));
            case 1:
              _yield$_this0$$awaitT = _context8.v;
              _yield$_this0$$awaitT2 = _slicedToArray(_yield$_this0$$awaitT, 2);
              err = _yield$_this0$$awaitT2[0];
              data = _yield$_this0$$awaitT2[1];
              if (!err) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, Promise.reject());
            case 2:
              if (data && data.data1 && data.data1.taskInfo) {
                form = data.data1.taskInfo;
                _this0.taskInfo = {
                  officeName: form.c01OfficeName,
                  startDate: form.c01StartDate,
                  endDate: form.c01EndDate,
                  taskCusName: form.c01CusName,
                  isPublic: form.c01IsPublic
                };
              }
              if (data && data.data2 && data.data2.roles) {
                _this0.roles = data.data2.roles;
              }
              return _context8.a(2, Promise.resolve());
          }
        }, _callee8);
      }))();
    },
    viewMap: function viewMap(type) {
      var _arguments3 = arguments,
        _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var key, text, params, _yield$_this1$$awaitT, _yield$_this1$$awaitT2, err, data;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              key = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : 'base';
              text = {
                view: '查看',
                computed: '计算'
              };
              params = {
                beginAddress: '',
                endAddress: '',
                warnMsg: '',
                beginAddressTitle: '',
                endAddressTitle: ''
              };
              if (key === 'base') {
                params.beginAddress = _this1.objForm.c03CorrectAddress;
                params.endAddress = _this1.baseForm.c02ObjAddress;
                params.warnMsg = '请先完善注册地址以及函证收件地址';
                params.beginAddressTitle = '注册地址';
                params.endAddressTitle = '快递发函收件地址';
              } else {
                params.beginAddress = _this1.baseForm.c02ObjAddress;
                params.endAddress = _this1.baseForm.c02BackAddress;
                params.warnMsg = '请先完善函证收件地址以及寄件地址';
                params.beginAddressTitle = '快递发函收件地址';
                params.endAddressTitle = '邮寄回函寄出地址';
              }
              _context9.n = 1;
              return _this1.$awaitTo(_this1.$dialog(CustomMap, {
                dialog: {
                  title: text[type],
                  width: '850px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: _objectSpread(_objectSpread({}, params), {}, {
                  type: type
                })
              }, function (template) {
                _this1.template = template;
              }));
            case 1:
              _yield$_this1$$awaitT = _context9.v;
              _yield$_this1$$awaitT2 = _slicedToArray(_yield$_this1$$awaitT, 2);
              err = _yield$_this1$$awaitT2[0];
              data = _yield$_this1$$awaitT2[1];
              _this1.template = null;
              if (!err) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              if (type === 'computed') {
                if (key !== 'base') {
                  _this1.baseForm.c02BackAddressDistance = data;
                  _this1.baseForm.c02BackCheckProcess = '天地图计算';
                  _this1.baseForm.c02BackAddressCheck = '天地图';
                  _this1.baseForm.c02BackAddressStatus = data > 2000 ? '异常' : '正常';
                } else {
                  _this1.baseForm.c02CheckDistance = data;
                  _this1.baseForm.c02CheckType = '天地图';
                }
              }
            case 3:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getFileUrl: function getFileUrl(id, name) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data, arr, fileName;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return getEditorFileSrc({
                f: id
              });
            case 1:
              data = _context0.v;
              arr = id.split('.');
              if (arr.length > 1 && name) {
                fileName = "".concat(name, ".").concat(arr[arr.length - 1]);
              }
              createObjectURL(data.data, fileName || id);
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    fileChange: function fileChange(files) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var formData, file, _yield$to, _yield$to2, err, data;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!(files && files.length)) {
                _context1.n = 3;
                break;
              }
              _this10.baseForm.c02SendFile1 = undefined;
              formData = new FormData();
              file = files[0];
              formData.append('file', file);
              formData.append('f', file.name);
              _context1.n = 1;
              return to(fileUpload(formData));
            case 1:
              _yield$to = _context1.v;
              _yield$to2 = _slicedToArray(_yield$to, 2);
              err = _yield$to2[0];
              data = _yield$to2[1].data;
              if (!err) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2, Promise.reject(err));
            case 2:
              _this10.baseForm.c02SendFile1 = data;
              // this.baseForm.c02TmpId = undefined;
              // this.tempParams = [];
              // this.tempDetail = {};
              // this.baseForm.c02Confirm = undefined;
            case 3:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    getFileUrl2: function getFileUrl2(download) {
      var _arguments4 = arguments,
        _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var fieldName, h, notify, _yield$_this11$$await, _yield$_this11$$await2, err, data, arr, fileName;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              fieldName = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : 'c02BackConfirmFile';
              if (!_this11.downloading) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              _this11.downloading = true;
              h = _this11.$createElement;
              notify = _this11.$notify({
                title: '下载提示',
                message: h('span', null, '数据正在生成, 请耐心等待')
              });
              _context10.n = 2;
              return _this11.$awaitTo(downloadFileByCreator(_this11.uid, _this11.id, {
                fieldName: fieldName
              }));
            case 2:
              _yield$_this11$$await = _context10.v;
              _yield$_this11$$await2 = _slicedToArray(_yield$_this11$$await, 2);
              err = _yield$_this11$$await2[0];
              data = _yield$_this11$$await2[1];
              notify.close();
              _this11.downloading = false;
              if (!err) {
                _context10.n = 3;
                break;
              }
              return _context10.a(2);
            case 3:
              arr = _this11.baseForm[fieldName].split('.');
              fileName = fieldName === 'c02BackConfirmFile' ? "".concat(_this11.baseForm.c02ConfirmCode, "-\u51FD\u8BC1\u626B\u63CF\u9644\u4EF6") : "".concat(_this11.baseForm.c02ConfirmCode, "-\u63D2\u4EF6\u63A8\u9001\u9644\u4EF6");
              if (arr.length > 1) {
                fileName = "".concat(fileName, ".").concat(arr[arr.length - 1]);
              }
              createObjectURL(data, download ? fileName : undefined);
            case 4:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    backConfirmFileChange: function backConfirmFileChange(files) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var formData, file, d, _yield$_this12$$await, _yield$_this12$$await2, err, data, _yield$_this12$$await3, _yield$_this12$$await4, _err3, _data;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!(files && files.length)) {
                _context11.n = 7;
                break;
              }
              _this12.baseForm.c02BackConfirmFile = undefined;
              formData = new FormData();
              _this12.uploading = true;
              file = files[0];
              formData.append('file', file);
              formData.append('fieldName', 'c02BackConfirmFile');
              if (!_this12.isCpscAdmin) {
                _context11.n = 3;
                break;
              }
              _context11.n = 1;
              return _this12.$awaitTo(uploadByCpsccAdmin(_this12.uid, formData));
            case 1:
              _yield$_this12$$await = _context11.v;
              _yield$_this12$$await2 = _slicedToArray(_yield$_this12$$await, 2);
              err = _yield$_this12$$await2[0];
              data = _yield$_this12$$await2[1];
              _this12.uploading = false;
              if (!err) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2, Promise.reject(err));
            case 2:
              d = data !== null && data !== void 0 ? data : undefined;
              _context11.n = 6;
              break;
            case 3:
              _context11.n = 4;
              return _this12.$awaitTo(uploadByCreator(_this12.uid, _this12.id, formData));
            case 4:
              _yield$_this12$$await3 = _context11.v;
              _yield$_this12$$await4 = _slicedToArray(_yield$_this12$$await3, 2);
              _err3 = _yield$_this12$$await4[0];
              _data = _yield$_this12$$await4[1];
              _this12.uploading = false;
              if (!_err3) {
                _context11.n = 5;
                break;
              }
              return _context11.a(2, Promise.reject(_err3));
            case 5:
              d = _data !== null && _data !== void 0 ? _data : undefined;
            case 6:
              _this12.baseForm.c02BackConfirmFile = d;
            case 7:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    waybillFileChange: function waybillFileChange(files, key) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var formData, file, d, _yield$_this13$$await, _yield$_this13$$await2, err, data, _yield$_this13$$await3, _yield$_this13$$await4, _err4, _data2;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (!(files && files.length)) {
                _context12.n = 7;
                break;
              }
              _this13.baseForm[key] = undefined;
              formData = new FormData();
              file = files[0];
              formData.append('file', file);
              formData.append('fieldName', key);
              // formData.append('f', file.name);
              if (!_this13.isCpscAdmin) {
                _context12.n = 3;
                break;
              }
              _context12.n = 1;
              return _this13.$awaitTo(uploadByCpsccAdmin(_this13.uid, formData));
            case 1:
              _yield$_this13$$await = _context12.v;
              _yield$_this13$$await2 = _slicedToArray(_yield$_this13$$await, 2);
              err = _yield$_this13$$await2[0];
              data = _yield$_this13$$await2[1];
              _this13.uploading = false;
              if (!err) {
                _context12.n = 2;
                break;
              }
              return _context12.a(2, Promise.reject(err));
            case 2:
              d = data !== null && data !== void 0 ? data : undefined;
              _context12.n = 6;
              break;
            case 3:
              _context12.n = 4;
              return _this13.$awaitTo(uploadByCreator(_this13.uid, _this13.id, formData));
            case 4:
              _yield$_this13$$await3 = _context12.v;
              _yield$_this13$$await4 = _slicedToArray(_yield$_this13$$await3, 2);
              _err4 = _yield$_this13$$await4[0];
              _data2 = _yield$_this13$$await4[1];
              _this13.uploading = false;
              if (!_err4) {
                _context12.n = 5;
                break;
              }
              return _context12.a(2, Promise.reject(_err4));
            case 5:
              d = _data2 !== null && _data2 !== void 0 ? _data2 : undefined;
            case 6:
              _this13.baseForm[key] = d;
            case 7:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    toPrint: function toPrint() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _yield$_this14$$await, _yield$_this14$$await2, err, data;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return _this14.$awaitTo(_this14.$dialog(PrintCode, {
                dialog: {
                  title: '打印函证编码',
                  width: '300px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  codes: [_this14.baseForm.c02ConfirmCode],
                  expressNum: _this14.baseForm.c02BackNumber,
                  expressName: _this14.baseForm.c02BackCompany
                }
              }, function (template) {
                _this14.template = template;
              }));
            case 1:
              _yield$_this14$$await = _context13.v;
              _yield$_this14$$await2 = _slicedToArray(_yield$_this14$$await, 2);
              err = _yield$_this14$$await2[0];
              data = _yield$_this14$$await2[1];
              _this14.template = null;
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    backConfirmFileChange2: function backConfirmFileChange2(files) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var formData, file, d, _yield$_this15$$await, _yield$_this15$$await2, err, data, _yield$_this15$$await3, _yield$_this15$$await4, _err5, _data3;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!(files && files.length)) {
                _context14.n = 7;
                break;
              }
              _this15.baseForm.c02SendFile1 = undefined;
              formData = new FormData();
              file = files[0];
              formData.append('file', file);
              formData.append('fieldName', 'c02SendFile1');
              // formData.append('f', file.name);
              if (!_this15.isCpscAdmin) {
                _context14.n = 3;
                break;
              }
              _context14.n = 1;
              return _this15.$awaitTo(uploadByCpsccAdmin(_this15.uid, formData));
            case 1:
              _yield$_this15$$await = _context14.v;
              _yield$_this15$$await2 = _slicedToArray(_yield$_this15$$await, 2);
              err = _yield$_this15$$await2[0];
              data = _yield$_this15$$await2[1];
              _this15.uploading = false;
              if (!err) {
                _context14.n = 2;
                break;
              }
              return _context14.a(2, Promise.reject(err));
            case 2:
              d = data !== null && data !== void 0 ? data : undefined;
              _context14.n = 6;
              break;
            case 3:
              _context14.n = 4;
              return _this15.$awaitTo(uploadByCreator(_this15.uid, _this15.id, formData));
            case 4:
              _yield$_this15$$await3 = _context14.v;
              _yield$_this15$$await4 = _slicedToArray(_yield$_this15$$await3, 2);
              _err5 = _yield$_this15$$await4[0];
              _data3 = _yield$_this15$$await4[1];
              _this15.uploading = false;
              if (!_err5) {
                _context14.n = 5;
                break;
              }
              return _context14.a(2, Promise.reject(_err5));
            case 5:
              d = _data3 !== null && _data3 !== void 0 ? _data3 : undefined;
            case 6:
              _this15.baseForm.c02SendFile1 = d;
            case 7:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    getTemDetail: function getTemDetail(id) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _yield$_this16$$await, _yield$_this16$$await2, err, data, _data$data, elements, tmp;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _this16.tempParams = [];
              _this16.tempDetail = {};
              _context15.n = 1;
              return _this16.$awaitTo(_getTemDetail({
                TmpGuid: id
              }));
            case 1:
              _yield$_this16$$await = _context15.v;
              _yield$_this16$$await2 = _slicedToArray(_yield$_this16$$await, 2);
              err = _yield$_this16$$await2[0];
              data = _yield$_this16$$await2[1];
              _this16.loading = false;
              if (!err) {
                _context15.n = 2;
                break;
              }
              return _context15.a(2);
            case 2:
              if (data.data) {
                _data$data = data.data, elements = _data$data.elements, tmp = _data$data.tmp;
                _this16.tempDetail = tmp;
                if (Array.isArray(elements)) {
                  _this16.tempParams = elements;
                  // this.C21ConfirmationDataForCreation = elements.map((child)=>{
                  //   return transformParamsToForm(child)
                  // });
                }
              }
            case 3:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    getOptions: function getOptions(type, key) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var _yield$_this17$$await, _yield$_this17$$await2, err, data;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return _this17.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: type
              }));
            case 1:
              _yield$_this17$$await = _context16.v;
              _yield$_this17$$await2 = _slicedToArray(_yield$_this17$$await, 2);
              err = _yield$_this17$$await2[0];
              data = _yield$_this17$$await2[1].data;
              if (!err) {
                _context16.n = 2;
                break;
              }
              return _context16.a(2, Promise.reject());
            case 2:
              if (Array.isArray(data.datas)) {
                _this17[key] = data.datas;
              }
              return _context16.a(2, Promise.resolve());
          }
        }, _callee16);
      }))();
    }
  }, mapActions('d2admin/page', ['close'])), {}, {
    changeRecord: function changeRecord(formName, key) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var title, _yield$_this18$$await, _yield$_this18$$await2, err, data;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              title = {
                c02CheckProcess: '注册vs收件地址核查过程说明',
                c02SendProcess: '发函/跟函记录'
              };
              _context17.n = 1;
              return _this18.$awaitTo(_this18.$dialog(Record, {
                dialog: {
                  title: title[key],
                  width: '800px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  str: _this18.baseForm[key],
                  title: title[key]
                }
              }, function (template) {
                _this18.template = template;
              }));
            case 1:
              _yield$_this18$$await = _context17.v;
              _yield$_this18$$await2 = _slicedToArray(_yield$_this18$$await, 2);
              err = _yield$_this18$$await2[0];
              data = _yield$_this18$$await2[1];
              _this18.template = null;
              if (!err) {
                _context17.n = 2;
                break;
              }
              return _context17.a(2);
            case 2:
              _this18[formName][key] = data;
            case 3:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    },
    removeBackConfirmFile: function removeBackConfirmFile(key) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return _this19.$$confirm('确定删除文件?');
            case 1:
              _this19.baseForm[key] = undefined;
            case 2:
              return _context18.a(2);
          }
        }, _callee18);
      }))();
    },
    removeFile1: function removeFile1() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              _context19.n = 1;
              return _this20.$$confirm('确定删除文件?');
            case 1:
              _this20.baseForm.c02SendFile1 = undefined;
            case 2:
              return _context19.a(2);
          }
        }, _callee19);
      }))();
    },
    back: function back() {
      if (this.formType === '1') {
        this.$router.push('/correspondence/send');
      } else {
        this.$router.push("/correspondence/control/".concat(this.id));
      }
      var tagName = this.current;
      this.close({
        tagName: tagName,
        onlyClose: true
      });
    },
    updateTemplate: function updateTemplate() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var type, _yield$_this21$$await, _yield$_this21$$await2, err, data;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              type = _this21.uid ? 'update' : 'create';
              _context20.n = 1;
              return _this21.$awaitTo(_this21.$dialog(TemplateContent, {
                dialog: {
                  title: type === 'create' ? '新增' : '编辑',
                  width: '1200px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  isInCorrespondence: true,
                  id: _this21.baseForm.c02TmpId,
                  taskId: _this21.id,
                  params: _this21.tempParams,
                  canBePreView: true,
                  data: _objectSpread({}, _this21.tempDetail),
                  sysParams: _this21.getSysParams,
                  confirmId: _this21.uid,
                  editVal: _this21.baseForm.c02Confirm,
                  type: type,
                  onlyRead: _this21.stepActive !== 0
                }
              }, function (template) {
                _this21.template = template;
              }));
            case 1:
              _yield$_this21$$await = _context20.v;
              _yield$_this21$$await2 = _slicedToArray(_yield$_this21$$await, 2);
              err = _yield$_this21$$await2[0];
              data = _yield$_this21$$await2[1];
              _this21.template = null;
              if (!err) {
                _context20.n = 2;
                break;
              }
              return _context20.a(2);
            case 2:
              _this21.baseForm.c02Confirm = data.data;
              // 如果是新增 先把数据转回详情接口返回的格式
              _this21.tempParams = data.params.map(function (item) {
                return transformParamsToData(item);
              });
            case 3:
              return _context20.a(2);
          }
        }, _callee20);
      }))();
    },
    transformParams: function transformParams() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return list.map(function (item) {
        return transformParamsToDataV2(item);
      });
    },
    getTemplateDetail: function getTemplateDetail() {
      var _this22 = this;
      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.baseForm.c02TmpId) {
        this.tempParams = [];
        this.tempDetail = {};
        this.baseForm.c02Confirm = undefined;
        return;
      }
      var res = this.templateList.find(function (item) {
        return item.ctId === _this22.baseForm.c02TmpId;
      });
      if (res) {
        if (update) {
          this.baseForm.c02Confirm = res.ctConfirm;
          this.getTemDetail(this.baseForm.c02TmpId);
        } else {
          this.tempDetail = {
            ctName: res.ctName
          };
        }
      } else {
        this.baseForm.c02Confirm = undefined;
      }
    },
    submit: function submit() {
      var _arguments5 = arguments,
        _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var isUpdate, tempParams, _yield$_this23$$await, _yield$_this23$$await2, formErr, isEmpty, c02ObjTel, _c02ObjTelName, _c02ObjTelPhone, c02BackConfirmExplain, obj, baseForm, o, _yield$_this23$$await3, _yield$_this23$$await4, err, data, _yield$_this23$$await5, _yield$_this23$$await6, _err6, _data4;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              isUpdate = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : true;
              if (!isUpdate) {
                _context21.n = 4;
                break;
              }
              _this23.customCheckForm = false;
              _context21.n = 1;
              return _this23.$nextTick();
            case 1:
              _context21.n = 2;
              return _this23.$awaitTo(_this23.$checkForm());
            case 2:
              _yield$_this23$$await = _context21.v;
              _yield$_this23$$await2 = _slicedToArray(_yield$_this23$$await, 1);
              formErr = _yield$_this23$$await2[0];
              if (!(typeof formErr === 'boolean' && !formErr || formErr)) {
                _context21.n = 3;
                break;
              }
              _this23.$message.error('请完善必要页面信息');
              return _context21.a(2);
            case 3:
              tempParams = _this23.transformParams(_this23.tempParams);
              isEmpty = _this23.tempParams.some(function (item) {
                return !item.account;
              });
              if (!isEmpty) {
                _context21.n = 4;
                break;
              }
              _this23.$message.error('函证模板元素报表科目项不能为空');
              return _context21.a(2);
            case 4:
              c02ObjTel = '';
              _c02ObjTelName = '';
              _c02ObjTelPhone = '';
              if (_this23.baseForm._c02ObjTelName) {
                _c02ObjTelName = _this23.baseForm._c02ObjTelName;
              }
              if (_this23.baseForm._c02ObjTelPhone) {
                _c02ObjTelPhone = _this23.baseForm._c02ObjTelPhone;
              }
              c02ObjTel = "".concat(_c02ObjTelName, "/").concat(_c02ObjTelPhone);

              // let c02BackConfirmExplain = this.baseForm.c02BackConfirmExplain
              // if (this.baseForm.c02BackConfirmExplain === '0' && this.baseForm._c02BackConfirmExplain) {
              //   c02BackConfirmExplain = `${this.baseForm.c02BackConfirmExplain}:${this.baseForm._c02BackConfirmExplain}`
              // }else {
              //   c02BackConfirmExplain = `${this.baseForm.c02BackConfirmExplain}:${this.baseForm._c02BackConfirmExplain}`
              // }

              // const obj = getBackConfirmExplain(this.baseForm.c02BackConfirmExplain, this.baseForm._c02BackConfirmExplain)
              // const c02BackConfirmExplain = `${obj.code}:${obj.msg}`

              if (_this23.baseForm.c02BackConfirmExplain && _this23.baseForm._c02BackConfirmExplain) {
                obj = getBackConfirmExplain(_this23.baseForm.c02BackConfirmExplain, _this23.baseForm._c02BackConfirmExplain);
                c02BackConfirmExplain = "".concat(obj.code, ":").concat(obj.msg);
              } else if (_this23.baseForm.c02BackConfirmExplain !== undefined) {
                c02BackConfirmExplain = _this23.baseForm.c02BackConfirmExplain;
              }
              baseForm = _objectSpread(_objectSpread({}, _this23.baseForm), {}, {
                c02ReturnStaff: "".concat(_this23.baseForm._c02ReturnStaff, "/").concat(_this23.baseForm._c02ReturnStaffPhone),
                c02ObjTel: c02ObjTel,
                c02BackConfirmExplain: c02BackConfirmExplain
              });
              _this23.loading = true;
              if (!_this23.uid) {
                _context21.n = 7;
                break;
              }
              o = _objectSpread(_objectSpread({}, _this23.baseData), baseForm);
              if (_this23.cpsccAdminPermissions || _this23.stepActive === 3 && _this23.stepThreePermissions) {
                if ((_this23.baseForm.c02BackType === '项目组邮件' || _this23.baseForm.c02BackType === '函证中心邮件') && _this23.baseForm.c02BackConfirmDate && _this23.baseForm.c02BackConfirmConclusion && _this23.baseForm.c02BackConfirmValid && _this23.baseForm.c02BackConfirmFile && _this23.baseForm.c02BackNumber && _this23.baseForm.c02BackCompany && _this23.baseForm.c02BackSendDate && _this23.baseForm.c02BackConfirmActualDate && _this23.baseForm.c02BackAddress && !_this23.baseData.c02BackConfirmName) {
                  o.c02BackConfirmName = _this23.isAdmin ? '管理员' : _this23.info.name;
                  o.c02BackConfirmOperateDate = new Date();
                }
              }
              _context21.n = 5;
              return _this23.$awaitTo(updateDetail(_this23.id, _this23.uid, o));
            case 5:
              _yield$_this23$$await3 = _context21.v;
              _yield$_this23$$await4 = _slicedToArray(_yield$_this23$$await3, 2);
              err = _yield$_this23$$await4[0];
              data = _yield$_this23$$await4[1];
              _this23.loading = false;
              if (!err) {
                _context21.n = 6;
                break;
              }
              return _context21.a(2, Promise.reject(err));
            case 6:
              _context21.n = 9;
              break;
            case 7:
              _context21.n = 8;
              return _this23.$awaitTo(create(_this23.id, {
                C02ConfirmationForCreation: baseForm,
                C21ConfirmationDataForCreation: tempParams
              }));
            case 8:
              _yield$_this23$$await5 = _context21.v;
              _yield$_this23$$await6 = _slicedToArray(_yield$_this23$$await5, 2);
              _err6 = _yield$_this23$$await6[0];
              _data4 = _yield$_this23$$await6[1];
              _this23.loading = false;
              if (!_err6) {
                _context21.n = 9;
                break;
              }
              return _context21.a(2, Promise.reject(_err6));
            case 9:
              _this23.loading = false;
              if (isUpdate) {
                _this23.$message.success('操作成功');
                if (_this23.uid) {
                  _this23.loading = true;
                  _this23.getDetail();
                }
              }
              return _context21.a(2, Promise.resolve());
          }
        }, _callee21);
      }))();
    },
    backNumberChange: function backNumberChange(value) {
      if (value) {
        var code = value.toLocaleLowerCase();
        var res = this.defaultAutoExpressCompany.find(function (item) {
          return code.indexOf(item.key) === 0;
        });
        if (res) {
          this.baseForm.c02BackCompany = res.name;
          return;
        } else {
          if (code.indexOf('1') === 0) {
            this.baseForm.c02BackCompany = 'EMS';
          }
        }
      }
      this.baseForm.c02BackCompany = undefined;
    },
    getInit: function getInit() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              // this.getOptions('c03CheckType','addressTypes');
              // this.getOptions('c02Type', 'types');
              // this.getOptions('c02CheckType', 'checkTypes');
              _this24.baseLoading = true;
              _context22.n = 1;
              return _this24.getOptions('c02SampleType', 'sampleTypes');
            case 1:
              _context22.n = 2;
              return _this24.getOptions('c02SendType', 'correspondenceTypes');
            case 2:
              _context22.n = 3;
              return _this24.getTaskDetail();
            case 3:
              if (_this24.uid) {
                _context22.n = 4;
                break;
              }
              _context22.n = 4;
              return _this24.getTemplateList();
            case 4:
              _this24.baseLoading = false;
            case 5:
              return _context22.a(2);
          }
        }, _callee22);
      }))();
    },
    cusNameHandleSelect: function cusNameHandleSelect(id) {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var item;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              item = _this25.dataSearchList.find(function (child) {
                return id === child.c03Id;
              });
              if (item) {
                _this25.objForm = item;
              } else {
                _this25.objForm = {};
              }
              _this25.updateCheckDistance();
            case 1:
              return _context23.a(2);
          }
        }, _callee23);
      }))();
    },
    getReceiversList: function getReceiversList(queryString) {
      var _arguments6 = arguments,
        _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var auto, _yield$_this26$$await, _yield$_this26$$await2, err, res, data, c03Id;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              auto = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : false;
              if (!(queryString !== '' && queryString !== undefined)) {
                _context24.n = 3;
                break;
              }
              _this26.searchLoading = true;
              _context24.n = 1;
              return _this26.$awaitTo(_getReceiversList({
                PageNumber: 1,
                PageSize: 20,
                SearchQuery: "c03CusName.contains(\"".concat(queryString, "\")")
              }));
            case 1:
              _yield$_this26$$await = _context24.v;
              _yield$_this26$$await2 = _slicedToArray(_yield$_this26$$await, 2);
              err = _yield$_this26$$await2[0];
              res = _yield$_this26$$await2[1];
              _this26.searchLoading = false;
              if (!err) {
                _context24.n = 2;
                break;
              }
              return _context24.a(2);
            case 2:
              data = res.data;
              _this26.dataSearchList = [];
              if (Array.isArray(data)) {
                _this26.dataSearchList = data;
                if (data.length && auto) {
                  c03Id = data[0].c03Id;
                  _this26.baseForm.c02C03Id = c03Id;
                  _this26.cusNameHandleSelect(c03Id);
                }
              }
            case 3:
              return _context24.a(2);
          }
        }, _callee24);
      }))();
    },
    getTemplateList: function getTemplateList() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var _yield$_this27$$await, _yield$_this27$$await2, err, data;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              _context25.n = 1;
              return _this27.$awaitTo(_getTemplateList({
                combineSearch: '',
                page: 1,
                length: 99999
              }));
            case 1:
              _yield$_this27$$await = _context25.v;
              _yield$_this27$$await2 = _slicedToArray(_yield$_this27$$await, 2);
              err = _yield$_this27$$await2[0];
              data = _yield$_this27$$await2[1];
              if (!err) {
                _context25.n = 2;
                break;
              }
              return _context25.a(2, Promise.reject());
            case 2:
              if (Array.isArray(data.data1)) {
                _this27.templateList = data.data1;
              }
              return _context25.a(2, Promise.resolve());
          }
        }, _callee25);
      }))();
    },
    getDetail: function getDetail() {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        var fn, _yield$_this28$$await, _yield$_this28$$await2, err, res, data, headers, form, key, returnStaffInfo, c02ObjTel, _c02ObjTelPhone, _c02ObjTelName, r, text, options, _yield$_this28$$await3, _yield$_this28$$await4, err1, res2, _data5;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              _this28.loading = true;
              clearTimeout(_this28.timer);
              fn = _this28.history ? getHistoryDetail : _getDetail;
              if (_this28.isCpscAdmin && _this28.formType === '1') {
                fn = _this28.history ? getHistoryC02Item : getC02Item;
              }
              _context27.n = 1;
              return _this28.$awaitTo(fn(_this28.uid, _this28.id));
            case 1:
              _yield$_this28$$await = _context27.v;
              _yield$_this28$$await2 = _slicedToArray(_yield$_this28$$await, 2);
              err = _yield$_this28$$await2[0];
              res = _yield$_this28$$await2[1];
              _this28.loading = false;
              if (!err) {
                _context27.n = 2;
                break;
              }
              return _context27.a(2);
            case 2:
              data = res.data, headers = res.headers;
              if (headers.etag) {
                _this28.eTag = headers.etag;
              }
              _this28.baseData = data;
              form = {};
              for (key in _this28.baseForm) {
                if (_this28.baseForm.hasOwnProperty(key)) {
                  form[key] = data[key];
                }
              }
              returnStaffInfo = form.c02ReturnStaff;
              if (returnStaffInfo && returnStaffInfo.indexOf('/') !== -1) {
                returnStaffInfo = returnStaffInfo.split('/');
              }
              c02ObjTel = form.c02ObjTel;
              if (c02ObjTel && c02ObjTel.indexOf('/') !== -1) {
                c02ObjTel = c02ObjTel.split('/');
                _c02ObjTelName = c02ObjTel[0];
                _c02ObjTelPhone = c02ObjTel[1];
              } else {
                _c02ObjTelPhone = c02ObjTel;
              }
              if (form.c02BackConfirmExplain.indexOf(':') === 1) {
                r = form.c02BackConfirmExplain.split(':');
                form.c02BackConfirmExplain = r[0];
                form._c02BackConfirmExplain = r[1];
              } else {
                if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(form.c02BackConfirmExplain)) {
                  text = form.c02BackConfirmExplain;
                  form.c02BackConfirmExplain = '0';
                  form._c02BackConfirmExplain = text;
                }
              }
              _context27.n = 3;
              return _this28.$nextTick();
            case 3:
              options = {};
              if ((_this28.isreplyPersonnel || _this28.isCpscAdmin) && (form.c02Status === '已发函' || form.c02Status === '已审核')) {
                if (!form.c02BackType) {
                  options.c02BackType = '函证中心邮件';
                }
                if (!form.c02BackConfirmConclusion) {
                  options.c02BackConfirmConclusion = '相符';
                }
                if (!form.c02BackConfirmValid) {
                  options.c02BackConfirmValid = '正常';
                }
              }
              _this28.baseForm = _objectSpread(_objectSpread(_objectSpread({}, form), options), {}, {
                _c02ReturnStaff: Array.isArray(returnStaffInfo) && returnStaffInfo[0] ? returnStaffInfo[0] : undefined,
                _c02ReturnStaffPhone: Array.isArray(returnStaffInfo) && returnStaffInfo[1] ? returnStaffInfo[1] : undefined,
                _c02ObjTelPhone: _c02ObjTelPhone,
                _c02ObjTelName: _c02ObjTelName,
                c02BackAddressReStatus: form.c02BackAddressReStatus === '待认' ? undefined : form.c02BackAddressReStatus,
                c02BackConfirmReConclusion: form.c02BackConfirmReConclusion === '待认' ? undefined : form.c02BackConfirmReConclusion
              });
              _context27.n = 4;
              return _this28.$nextTick();
            case 4:
              _this28.timer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
                var _res2;
                return _regenerator().w(function (_context26) {
                  while (1) switch (_context26.n) {
                    case 0:
                      _context26.n = 1;
                      return _this28.getTemplateList();
                    case 1:
                      _this28.getTemplateDetail(false);
                      // 导入进来的函证没有模板数据, 需要自动带出来
                      if (_this28.baseForm.c02TmpId && !_this28.baseForm.c02Confirm) {
                        _res2 = _this28.templateList.find(function (item) {
                          return item.ctId === _this28.baseForm.c02TmpId;
                        });
                        if (_res2) {
                          _this28.baseForm.c02Confirm = _res2.ctConfirm;
                        }
                      }
                      _this28.$refs.form.clearValidate();
                      _this28.convertImageToCanvas(_this28.baseForm.c02ConfirmCode);
                      // this.getTemDetail(form.c02TmpId);
                    case 2:
                      return _context26.a(2);
                  }
                }, _callee26);
              })), 300);
              if (!form.c02C03Id) {
                _context27.n = 7;
                break;
              }
              _context27.n = 5;
              return _this28.$awaitTo(getReceiver(form.c02C03Id));
            case 5:
              _yield$_this28$$await3 = _context27.v;
              _yield$_this28$$await4 = _slicedToArray(_yield$_this28$$await3, 2);
              err1 = _yield$_this28$$await4[0];
              res2 = _yield$_this28$$await4[1];
              if (!err1) {
                _context27.n = 6;
                break;
              }
              return _context27.a(2);
            case 6:
              _data5 = res2.data;
              _this28.dataSearchList = [_data5];
              _this28.objForm = _data5;
              _this28.updateCheckDistance();
            case 7:
              if (_this28.baseForm.c02ObjMobile) {
                _this28.expressNo_Send = _this28.baseForm.c02ObjMobile.slice(_this28.baseForm.c02ObjMobile.length - 4);
              }
              _this28.getModelValues();
            case 8:
              return _context27.a(2);
          }
        }, _callee27);
      }))();
    },
    createObj: function createObj() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var _yield$_this29$$await, _yield$_this29$$await2, err, data;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              _context28.n = 1;
              return _this29.$awaitTo(_this29.$dialog(Details, {
                dialog: {
                  title: '新增函证对象',
                  width: '1100px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  type: 'create',
                  taskId: _this29.id
                }
              }, function (template) {
                _this29.template = template;
              }));
            case 1:
              _yield$_this29$$await = _context28.v;
              _yield$_this29$$await2 = _slicedToArray(_yield$_this29$$await, 2);
              err = _yield$_this29$$await2[0];
              data = _yield$_this29$$await2[1];
              _this29.template = null;
              if (!err) {
                _context28.n = 2;
                break;
              }
              return _context28.a(2);
            case 2:
              _this29.$message.success('操作成功，请输入新增函证对象名称并选中');
              _this29.getReceiversList(data, true);
            case 3:
              return _context28.a(2);
          }
        }, _callee28);
      }))();
    },
    scrollTo: function scrollTo(id) {
      // container
      // document.documentElement.scrollTop = 300

      // console.log(this.$refs[`step-${id}`].offsetTop)
      this.$refs["step-".concat(id)].scrollIntoView();
    },
    getModelValues: function getModelValues() {
      var res = localStorage.getItem(this.localStorageName);
      if (res) {
        var obj = JSON.parse(res);
        this.cpsccAdminStore = obj;
      }
    },
    c02CheckTypeChange: function c02CheckTypeChange(value) {
      if (value === '人工') {
        this.baseForm.c02CheckDistance = -1;
      } else {
        this.baseForm.c02CheckDistance = undefined;
      }
    },
    showAltimeter: function showAltimeter(type, name) {
      var _this30 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29() {
        var _yield$_this30$$await, _yield$_this30$$await2, err, files;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              _context29.n = 1;
              return _this30.$awaitTo(_this30.$dialog(Altimeter, {
                dialog: {
                  title: '高拍仪上传',
                  width: '1200px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  code: _this30.baseForm.c02ConfirmCode,
                  name: name
                }
              }, function (template) {
                _this30.template = template;
              }));
            case 1:
              _yield$_this30$$await = _context29.v;
              _yield$_this30$$await2 = _slicedToArray(_yield$_this30$$await, 2);
              err = _yield$_this30$$await2[0];
              files = _yield$_this30$$await2[1];
              _this30.template = null;
              if (!err) {
                _context29.n = 2;
                break;
              }
              return _context29.a(2);
            case 2:
              if (type === 1) {
                _this30.waybillFileChange(files, 'c02SendWaybill');
              } else if (type === 2) {
                _this30.backConfirmFileChange(files);
              } else if (type === 3) {
                _this30.waybillFileChange(files, 'c02BackWaybill');
              }
            case 3:
              return _context29.a(2);
          }
        }, _callee29);
      }))();
    }
  }),
  created: function created() {
    this.getInit();
  },
  mounted: function mounted() {
    var _this31 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30() {
      return _regenerator().w(function (_context30) {
        while (1) switch (_context30.n) {
          case 0:
            if (_this31.uid) {
              _this31.getDetail();
              _this31.$store.dispatch('cpscc/getExpressInfo');
            }
          case 1:
            return _context30.a(2);
        }
      }, _callee30);
    }))();
  },
  filters: {
    km: function km(val) {
      if (!val) {
        return '0(m)';
      }
      if (val >= 0 && val < 1000) {
        return "".concat(val, "(m)");
      }
      return "".concat((val / 1000).toFixed(2), "(km)");
    }
  }
};